export default "__VITE_ASSET__CIrNalfI__"